import { Hero } from '../sections/Hero';
import { AppShowcase } from '../sections/AppShowcase';
import { ClientGrid } from '../sections/ClientGrid';
import { ServicesGrid } from '../sections/ServicesGrid';
import { CTASection } from '../sections/CTASection';
import { PageHead } from '../seo';

export function Home() {
  return (
    <>
      <PageHead
        title="Lancaster Systems Automation — Apps & Custom Development"
        description="We craft innovative apps and custom software solutions that simplify life and drive business growth. Explore our product suite or partner with us on your next project."
      />
      <Hero
        title={
          <>
            Building Tomorrow's{' '}
            <span className="gradient">Digital Ecosystem</span>
          </>
        }
        subtitle="We craft innovative apps and custom software solutions that simplify life and drive business growth. Explore our product suite or partner with us on your next project."
      />

      <AppShowcase limit={4} />

      <ClientGrid showViewAll={false} />

      <ServicesGrid limit={4} />

      <CTASection />
    </>
  );
}

export default Home;
